<template>
  <qz-results-details
    :quote="selectedQuote"
    :details-description="detailsDescription"
    :selected-premium="selectedPremium"
    :selected-optional-extras="selectedOptionalExtras"
    :is-details-drawer-open="isDetailsDrawerOpen"
    :policy-type="policyType"
    :filter-extras="filterExtras"
    :quote-position-number="quotePositionNumber"
    @go-to-form="$emit('go-to-form')"
    @close-drawer="$emit('close-drawer')"
    @open-drawer-details="$emit('open-drawer-details', $event)"
  />
</template>

<script>
import QzResultsDetails from '@/components/travel/Results/QzResultsDetails';
import { isEmpty } from 'lodash';

export default {
  name: 'results-details',
  components: {
    QzResultsDetails,
  },
  props: {
    selectedPremium: {
      type: Object,
      default: undefined,
    },
    quote: {
      required: false,
      type: Object,
      default: undefined,
    },
    detailsDescription: {
      type: Object,
      required: true,
    },
    selectedOptionalExtras: {
      type: Array,
      required: true,
    },
    isDetailsDrawerOpen: {
      type: Boolean,
      required: true,
    },
    quoteSummary: {
      type: Object,
      default: () => {},
    },
    quotePositionNumber: {
      required: true,
      type: Number,
    },
  },
  computed: {
    selectedQuote () {
      return this.selectedPremium || this.quote;
    },
    quoteDetails () {
      return this.selectedQuote?.details?.[0] || null;
    },
    policyType () {
      return this.quoteSummary && Object.keys(this.quoteSummary).length
        ? this.quoteSummary['Your Trip']['Type of cover']
        : '';
    },
  },
  methods: {
    filterExtras (condition) {
      const filteredExtras = Object.keys(this.quoteDetails.optionalExtra).filter(
        cover => this.quoteDetails.optionalExtra[cover]?.included === condition && this.quoteDetails.optionalExtra[cover]?.description !== 'DO_NOT_SHOW',
      ).map(cover => {
        return {
          name: cover,
          value: this.quoteDetails.optionalExtra[cover],
        };
      });

      return isEmpty(filteredExtras) ? null : filteredExtras;
    },
  },
};
</script>
